export class GlobalHeader {

	constructor (common) {
		// console.log('GlobalHeader');

		this.common = common;
		this.view = document.querySelector('.cmn_global_header');

		this.view.navi = document.querySelector('.cmn_global_header .navi');
		this.view.navi.icon = document.querySelector('.cmn_global_header .icon');
		this.view.navi.list = document.querySelector('.cmn_global_header .menu');

		this.view.navi.icon.addEventListener('click', e => {
			e.preventDefault()
			this.naviToggle();
		})
        this.common.view.addEventListener('resize:responsive:PC', () => {
			this.naviHide();
		});

		this.view.startPos = 0;
		this.view.header = document.querySelector('.cmn_global_header');
		this.view.header.height = this.view.header.offsetHeight;

		this.common.view.addEventListener('scroll', () => {
			this.view.scrollPos = document.documentElement.scrollTop || document.body.scrollTop;
			// console.log(`${this.view.scrollPos} > ${this.view.startPos}  または  ${this.view.scrollPos} > ${this.view.header.height}`);
			if ( this.view.scrollPos > this.view.startPos && this.view.scrollPos > this.view.header.height ) {
				this.view.header.classList.remove('is-scrollup');
			} else {
				this.view.header.classList.add('is-scrollup');
			}
			this.view.startPos = this.view.scrollPos;

		});


	}

	naviToggle () {
        if (!this.view.navi.classList.contains('open')) {
			this.naviShow();
		} else {
			this.naviHide();
		}
	}

	naviShow () {
        this.view.navi.classList.add('open');
		bodyScrollLock.disableBodyScroll(this.view.navi.list);
	}

	naviHide () {
        this.view.navi.classList.remove('open');
		bodyScrollLock.clearAllBodyScrollLocks();
	}
}

